import { render, staticRenderFns } from "./OrdemColeta.vue?vue&type=template&id=478433ec"
import script from "./OrdemColeta.vue?vue&type=script&lang=js"
export * from "./OrdemColeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports